const timeFilter = value => {
  let numToStr = number => (number > 9 ? number.toString() : '0' + number)
  let hr = parseInt((value / 60 / 60 % 24).toString())
  let min = parseInt((value / 60 % 60).toString())
  let sec = parseInt((value % 60).toString())
  return `${numToStr(hr)}:${numToStr(min)}:${numToStr(sec)}`
}

export default {
  timeFilter
}
